import * as React from 'react';
import clsx from 'clsx';
import { ManualPopover, IManualPopover, CloseButton } from 'components/index';
import './style.scss';

interface IHelpButtonWithPopoverProps extends React.HTMLAttributes<HTMLDivElement> {
    popoverProps?: Omit<Partial<IManualPopover>, 'open'>;
    offset?: [number, number]
}

export const HelpButtonWithPopover = ({
    popoverProps = {},
    className: classNameForDiv,
    children,
    offset,
    ...restDivProps
}: IHelpButtonWithPopoverProps) => {
    const referenceElement = React.useRef<HTMLDivElement>(null);
    const [ showPopover, setShowPopover ] = React.useState<boolean>(false);
    const [ arrowRef, setArrowRef ] = React.useState<HTMLSpanElement>(null);
    let {
        ref,
        ...restPopoverProps
    } = popoverProps;
    return (
        <React.Fragment>
            <div
                ref={referenceElement}
                className={clsx('category-panel-item__name-actions-help', classNameForDiv)}
                onClick={(e) => {
                    e.stopPropagation();
                    setShowPopover(true);
                }}
                {...restDivProps}
            >
                ?
            </div>

            <ManualPopover
                targetElement={referenceElement}
                open={showPopover}
                onClickAway={() => setShowPopover(false)}
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: offset || [ 0, 44 ]
                        }
                    },
                    {
                        name: 'arrow',
                        options: {
                            // 'enabled': true,
                            'element': arrowRef,
                            'padding': 2
                        }
                    }, {
                        name: 'keepTogether',
                        options: {
                            'enabled': true
                        }
                    }
                ]}
                placement="right-start"
                {...restPopoverProps}
            >
                <CloseButton
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowPopover(false);
                    }}
                />
                <span
                    ref={setArrowRef}
                    className='popper-arrow'
                />
                { children }
            </ManualPopover>
        </React.Fragment>
    );
};
